import { useContext } from "react";
import { ErrorContext } from "../contexts/ErrorContext";

function useApiError() {
    const { error, addError, removeError } = useContext(ErrorContext);
    return { error, addError, removeError };
}

export default useApiError;